var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "38.511 39.716 122.978 120.569",
    viewBox: "38.511 39.716 122.978 120.569",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-mb08u5yf__item-kl57gi80 svg [data-color=\"1\"] {fill: #FFFFFF;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M158.536 50.896H41.464a2.956 2.956 0 0 1-2.953-2.953v-5.274a2.956 2.956 0 0 1 2.953-2.953h117.072a2.956 2.956 0 0 1 2.953 2.953v5.274a2.956 2.956 0 0 1-2.953 2.953zM42.237 47.169h115.525v-3.727H42.237v3.727z",
    fill: "#FFFFFF",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.536 129.155H41.464a2.956 2.956 0 0 1-2.953-2.953v-5.273a2.956 2.956 0 0 1 2.953-2.953h117.072a2.956 2.956 0 0 1 2.953 2.953v5.273a2.956 2.956 0 0 1-2.953 2.953zm-116.299-3.727h115.525v-3.726H42.237v3.726z",
    fill: "#FFFFFF",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M50.622 47.488v70.806h-3.727V47.488h3.727z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M153.104 49.352v70.806h-3.727V49.352h3.727z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M114.906 132.881v3.727H85.093v-3.727h29.813z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M101.864 136.608v11.18h-3.727v-11.18h3.727z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M111.857 160.285L100 148.427l-11.857 11.858-2.636-2.635L100 143.157l14.493 14.493-2.636 2.635z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.193 97.21a1.866 1.866 0 0 1-1.864-1.866l.029-23.033a1.864 1.864 0 0 1 2.959-1.506l15.848 11.517a1.863 1.863 0 0 1-.001 3.015L96.287 96.855a1.858 1.858 0 0 1-1.094.355zm1.887-21.242l-.02 15.722 10.838-7.861-10.818-7.861z",
    fill: "#FFFFFF",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 108.046c-13.357 0-24.223-10.866-24.223-24.223S86.643 59.599 100 59.599s24.223 10.866 24.223 24.223-10.866 24.224-24.223 24.224zm0-44.72c-11.302 0-20.496 9.195-20.496 20.496s9.195 20.496 20.496 20.496 20.496-9.195 20.496-20.496S111.302 63.326 100 63.326z",
    fill: "#FFFFFF",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f5ce68b56ffad80d77dba8472db246a2.svg";
export { ForwardRef as ReactComponent };